import axios from 'axios'; /* TODO: Setup and use Axios API instance */
import { endpoint, API_BASE_URL, MESSAGE_API_ENDPOINTS } from '@utils/api/endpoints';

export default {
	namespaced: true,

	actions: {
		async GetMessages(_, { receivedByID = null, sentByID = null }) {
			if (!receivedByID || !sentByID) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Argument not provided' });
			try {
				const url = endpoint(API_BASE_URL, MESSAGE_API_ENDPOINTS.GET_CONVERSATION, {
					params: {
						receivedByID,
						sentByID,
					},
				});
				const results = await axios.patch(url);
				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load hash' });
				return results.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async CreateMessage(_, { messageItem = {} }) {
			if (!messageItem) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Argument not provided' });
			try {
				const url = endpoint(API_BASE_URL, MESSAGE_API_ENDPOINTS.CREATE_MESSAGE);
				const results = await axios.post(url, messageItem);
				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load hash' });
				return results.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async GetConversationUnreadCount(_, { receivedByID = null, sentByID = null }) {
			if (!receivedByID || !sentByID) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Argument not provided' });
			try {
				const url = endpoint(API_BASE_URL, MESSAGE_API_ENDPOINTS.GET_CONVERSATION_UNREAD_COUNT, {
					params: {
						receivedByID,
						sentByID,
					},
				});
				const results = await axios.get(url);
				if (!results.data && results.data < 0) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load hash' });
				return results.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async GetTotalUnreadCount(_, { receivedByID = null }) {
			if (!receivedByID) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Argument not provided' });
			try {
				const url = endpoint(API_BASE_URL, MESSAGE_API_ENDPOINTS.GET_TOTAL_UNREAD_COUNT, {
					params: {
						receivedByID,
					},
				});
				const results = await axios.get(url);
				if (!results.data && results.data < 0) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load hash' });
				return results.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},

		async GetUnreadChats(_, { receivedByID = null }) {
			if (!receivedByID) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Argument not provided' });
			try {
				const url = endpoint(API_BASE_URL, MESSAGE_API_ENDPOINTS.GET_UNREAD_CHATS, {
					params: {
						receivedByID,
					},
				});
				const results = await axios.get(url);
				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load hash' });
				return results.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},
	},
};
